import styled, { css } from "styled-components";

import { colors } from "shared/ui/tokens";

export const Title = styled.h2`
    margin: 0;
    font-size: 1.0625rem;
    font-weight: 600;
    line-height: 1.2;
    color: ${colors.textPrimary};
`;

export const Body = styled.div<{ $fillHeight?: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 4px;

    ${({ $fillHeight }) =>
        $fillHeight &&
        css`
            height: 100%;
            min-height: 0;
        `}
`;

export const Actions = styled.div`
    /* На всю ширину: иначе строка действий сжимается по содержимому, и распорка внутри
       неё (кнопка удаления слева, «Отмена / Сохранить» справа) не за что не цепляется. */
    width: 100%;
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    flex-wrap: wrap;
`;
